/* apps/viewer/src/app/toc-items/note-module/webtek-dialog/web-tek-dialog.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
::ng-deep .webTek-dialog-container {
  height: 400px;
  width: 350px;
}
::ng-deep .webTek-dialog-container .mat-mdc-dialog-container {
  overflow: hidden;
  padding: 0;
}
@media only screen and (max-width: 1024px) {
  ::ng-deep .webTek-dialog-container {
    height: 100%;
    max-height: 100vh !important;
    max-width: 100vw !important;
    width: 100%;
  }
}
@media only screen and (max-height: 400px) {
  ::ng-deep .webTek-dialog-container {
    height: 100%;
    max-height: 100vh !important;
    max-width: 100vw !important;
    width: 100%;
  }
}
.header {
  align-items: center;
  box-sizing: border-box;
  color: #fafafa;
  display: flex;
  flex-direction: row;
  height: 50px;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 0;
}
.header ::ng-deep svg {
  height: 30px;
  width: 30px;
}
.header .icon {
  align-items: center;
  cursor: pointer;
  display: flex;
  fill: #fafafa;
  height: 50px;
  justify-content: center;
  max-width: 20%;
  transition: all ease 0.3s;
  width: 50px;
}
.header .icon ::ng-deep svg {
  height: 30px;
  transition: all ease 0.3s;
  width: 30px;
}
.header .icon:hover,
.header .icon:focus {
  transition: all ease 0.3s;
}
.header .icon:hover ::ng-deep svg,
.header .icon:focus ::ng-deep svg {
  fill: #fafafa;
  transition: all ease 0.3s;
}
.content {
  display: flex;
  flex-direction: column;
  height: calc(100% - 150px);
}
.content .webTek-spinner-wrapper {
  align-items: center;
  display: flex;
  height: 100%;
  width: 100%;
}
.content .webTek-spinner-wrapper .webTek-spinner {
  margin: auto;
}
.content .webTek-message-success,
.content .webTek-reference-success,
.content .webTek-message-to-complete,
.content .webTek-message-validation {
  align-self: center;
  font-weight: bold;
  padding: 50px 20px 20px;
  text-align: center;
}
.content .webTek-message-success {
  color: #6faf41;
  padding-bottom: 5px;
}
.content .webTek-message-to-complete {
  color: #fb8033;
  padding-bottom: 5px;
}
.content .open-webTek {
  align-items: center;
  align-self: center;
  display: flex;
  width: fit-content;
}
.content .open-webTek .open-webTek-icon {
  margin-left: 8px;
}
.action-buttons {
  display: block;
  text-align: center;
}
@media only screen and (max-width: 1024px), screen and (max-height: 500px) {
  .header {
    margin-bottom: 2rem;
  }
  .content {
    height: auto;
    margin-bottom: 3%;
    margin-top: 1%;
  }
  ::ng-deep .mat-mdc-dialog-actions {
    padding: 0;
  }
}
/*# sourceMappingURL=web-tek-dialog.component.css.map */
